<script>
export default {
  name: 'SearchResults',
  props: {
    filterMenuButtonLabel: {
      type: String,
      default: '',
    },
    filterMenuButtonLabelOpened: {
      type: String,
      default: '',
    },
    suggestionsLabel: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      filterOpened: false,
      filterButtonInitialized: false,
      noResults: false,
      searchInterface: null,
    };
  },
  mounted() {
    this.searchInterface = this.$el.querySelector('.CoveoSearchInterface');

    this.searchInterface.addEventListener(Coveo.InitializationEvents.afterComponentsInitialization, () => {
      this.$el.querySelector('[role="listbox"]').setAttribute('aria-label', this.suggestionsLabel);
      this.$el.querySelector('[role="combobox"]').setAttribute('aria-label', this.suggestionsLabel);
    });

    this.searchInterface.addEventListener('afterInitialization', () => {
      this.createComponentObserver();
      this.searchInterface.addEventListener('querySuccess', this.checkIfNoResults);
    });
  },
  watch: {
    filterOpened() {
      if (this.filterOpened) {
        document.documentElement.classList.add('search-filters-menu-opened');
        this.$el.querySelector('.coveo-facet-dropdown-header > p').textContent = this.filterMenuButtonLabelOpened;
      } else {
        document.documentElement.classList.remove('search-filters-menu-opened');
        this.$el.querySelector('.coveo-facet-dropdown-header > p').textContent = this.filterMenuButtonLabel;
      }
    },
    noResults() {
      if (this.noResults) {
        this.searchInterface.classList.add('search-no-results');
      } else {
        this.searchInterface.classList.remove('search-no-results');
      }
    },
  },
  methods: {
    createComponentObserver() {
      const observer = new MutationObserver(this.handleMutations);
      observer.observe(this.searchInterface, { attributes: true, attributeFilter: ['class'] });
    },
    handleMutations(mutations) {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (mutation.target.classList.contains('coveo-small-interface')) {
            if (this.filterButtonInitialized) return;

            const dropdownHeader = this.$el.querySelector('.coveo-facet-dropdown-header');
            if (!dropdownHeader) return;

            this.bindEventsToFilterMenuButton(dropdownHeader);
            this.addFilterMenuTitleElement();
            this.filterButtonInitialized = true;
          } else if (this.filterButtonInitialized) {
            this.removeFilterMenuTitleElement();
            this.filterButtonInitialized = false;
          }
        }
      });
    },
    addFilterMenuTitleElement() {
      const filterButtonTitleElement = document.createElement('div');
      filterButtonTitleElement.classList.add('search-filters-menu-title');
      filterButtonTitleElement.innerHTML = this.filterMenuButtonLabel;

      this.$el.querySelector('.coveo-dropdown-header-wrapper').prepend(filterButtonTitleElement);
    },
    removeFilterMenuTitleElement() {
      const filterTitle = this.$el.querySelector('.coveo-dropdown-header-wrapper .search-filters-menu-title');
      if (!filterTitle) return;

      filterTitle.parentNode.removeChild(filterTitle);
    },
    bindEventsToFilterMenuButton(dropdownHeader) {
      if (!dropdownHeader) return;

      this.filterOpened = dropdownHeader.classList.contains('coveo-dropdown-header-active');
      dropdownHeader.addEventListener('click', this.handleFilterButtonClick);
      dropdownHeader.addEventListener('keyup', this.handleFilterButtonKeyup);
    },
    checkIfNoResults() {
      this.noResults = this.$el.querySelector('.coveo-results-column').classList.contains('coveo-no-results');
    },
    handleFilterButtonClick() {
      // eslint-disable-next-line max-len
      this.filterOpened = this.$el.querySelector('.coveo-facet-dropdown-header').classList.contains('coveo-dropdown-header-active');
    },
    handleFilterButtonKeyup(e) {
      if (e.code === 'Space' || e.code === 'Enter') {
        this.handleFilterButtonClick();
      }
    },
  },
};
</script>
